import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">{updatesData.title}</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">{updatesData.subtitle}</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-300">
            {updatesData.items.map((item, i) => (
              <div key={i} className="relative mb-8 last:mb-0">
                <div className="absolute -left-[calc(2rem+5px)] top-0 w-2 h-2 bg-primary-500 rounded-full ring-4 ring-background-100"></div>
                <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-500 font-medium">{item.time}</span>
                    <span className={`px-1.5 py-0.5 text-[10px] font-bold rounded whitespace-nowrap ${
                      item.tag === '突发' ? 'bg-primary-500 text-background-50' :
                      item.tag === '独家' ? 'bg-accent-500 text-background-50' :
                      'bg-secondary-500 text-background-50'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}